import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/** Returns { wallet, loading, refresh } for the current user. */
export default function useMyWallet() {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/me/wallet");
      setWallet(data?.wallet || null);
    } catch (_) {
      setWallet(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { wallet, loading, refresh: load };
}
